import { BidPointViewModel } from "api";
import { bidRefuelingServiceTypesEnum } from "helpers/enums";
import { PolicyOptionsModel, PunditUser } from "policies";

export default function (actions: {
    [x: string]: (args: {
        context: any;
        user: PunditUser;
        record: any;
        options: PolicyOptionsModel;
        userPolicy?: { [x: string]: () => boolean };
        usesBidsApproval?: boolean;
        point?: BidPointViewModel;
        last?: boolean;
        refuelingServiceType?: keyof typeof bidRefuelingServiceTypesEnum;
        refuelingSettings?: { hideRefuelingPlanning: boolean };
        changedData?: { name: string; value: any };
        value?: number;
        previousPointVisited?: boolean;
    }) => boolean;
}) {
    class Policy {
        user: PunditUser;
        record: any;
        options: PolicyOptionsModel;
        constructor(args: { user: PunditUser; record: any; options: PolicyOptionsModel }) {
            this.user = args.user;
            this.record = args.record;
            this.options = args.options;

            Object.keys(actions).forEach((action) => {
                (this as any)[action] = (actionArgs = {}) => actions[action]({ context: this, ...args, ...actionArgs });
            });
        }
    }

    return Policy;
}
